import { toHex } from './bytes.js';
import { DOMAIN, hashCanonical } from './hash.js';
import { jwkThumbprint } from './keys.js';
/**
 * Short authentication strings: 64 word/emoji pairs, 6 bits each. Word i and emoji i always
 * render the same bits, so a terminal can show words while the PWA shows "🍎 apple".
 */
// biome-ignore format: keep the 4-per-row table
export const SAS_PAIRS = [
    ['apple', '🍎'], ['banana', '🍌'], ['cherry', '🍒'], ['grape', '🍇'],
    ['lemon', '🍋'], ['melon', '🍈'], ['peach', '🍑'], ['pear', '🍐'],
    ['carrot', '🥕'], ['corn', '🌽'], ['mushroom', '🍄'], ['bread', '🍞'],
    ['cheese', '🧀'], ['egg', '🥚'], ['pizza', '🍕'], ['taco', '🌮'],
    ['cake', '🎂'], ['cookie', '🍪'], ['donut', '🍩'], ['candy', '🍬'],
    ['coffee', '☕'], ['tea', '🍵'], ['milk', '🥛'], ['honey', '🍯'],
    ['dog', '🐶'], ['cat', '🐱'], ['mouse', '🐭'], ['rabbit', '🐰'],
    ['fox', '🦊'], ['bear', '🐻'], ['panda', '🐼'], ['koala', '🐨'],
    ['tiger', '🐯'], ['lion', '🦁'], ['cow', '🐮'], ['pig', '🐷'],
    ['frog', '🐸'], ['monkey', '🐵'], ['chicken', '🐔'], ['penguin', '🐧'],
    ['bird', '🐦'], ['duck', '🦆'], ['owl', '🦉'], ['horse', '🐴'],
    ['unicorn', '🦄'], ['bee', '🐝'], ['snail', '🐌'], ['turtle', '🐢'],
    ['snake', '🐍'], ['octopus', '🐙'], ['crab', '🦀'], ['whale', '🐳'],
    ['fish', '🐟'], ['shark', '🦈'], ['tree', '🌲'], ['cactus', '🌵'],
    ['flower', '🌸'], ['sun', '🌞'], ['moon', '🌙'], ['star', '⭐'],
    ['rainbow', '🌈'], ['fire', '🔥'], ['rocket', '🚀'], ['car', '🚗'],
];
export const SAS_LENGTH = 5;
/** Derive a SAS from any canonical-JSON transcript. */
export async function deriveSas(transcript) {
    const digest = await hashCanonical(DOMAIN.sas, transcript);
    const words = [];
    const emoji = [];
    let acc = 0;
    let bits = 0;
    let i = 0;
    while (words.length < SAS_LENGTH) {
        acc = (acc << 8) | digest[i++];
        bits += 8;
        while (bits >= 6 && words.length < SAS_LENGTH) {
            bits -= 6;
            const pair = SAS_PAIRS[(acc >> bits) & 63];
            words.push(pair[0]);
            emoji.push(pair[1]);
        }
        acc &= (1 << bits) - 1;
    }
    const hex = (toHex(digest.subarray(0, 16)).match(/.{4}/g) ?? []).join(' ');
    return { words, emoji, hex };
}
/** Human-comparable fingerprint of a public key (device list, daemon list, audit log). */
export async function keyFingerprint(jwk) {
    return deriveSas({ type: 'viko.key-fingerprint', thumbprint: await jwkThumbprint(jwk) });
}
//# sourceMappingURL=sas.js.map